import { render } from "./HelloWorld.vue?vue&type=template&id=e80a9cde"
import script from "./HelloWorld.vue?vue&type=script&setup=true&lang=js"
export * from "./HelloWorld.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/Volumes/Projects/wp_lab/wp-content/plugins/debug-log-config-tool-x/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/components/HelloWorld.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e80a9cde"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e80a9cde', __exports__)) {
    console.log('reload')
    api.reload('e80a9cde', __exports__)
  }
  
  module.hot.accept("./HelloWorld.vue?vue&type=template&id=e80a9cde", () => {
    console.log('re-render')
    api.rerender('e80a9cde', render)
  })

}


export default __exports__